import(/* webpackMode: "eager" */ "/var/www/vhosts/dailyneedsproducts.com/httpdocs/src/app/crazy-deals/page.tsx");
